import { render, staticRenderFns } from "./storeprocess.vue?vue&type=template&id=736fdfb6"
import script from "./storeprocess.vue?vue&type=script&lang=js"
export * from "./storeprocess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports